// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y_S3","content":"styles_content__39pm_","tableWrap":"styles_tableWrap__2mffN"};